import React from 'react';

const SvgVideoFolder = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" {...props} viewBox={'0 0 29 22'}>
    <path
      d="M10.435 7.183v9.16l8.143-4.58-8.143-4.58Zm.999 1.71 5.103 2.87-5.103 2.87v-5.74Z"
      fill="currentColor"
    />
    <path
      d="M10.607.5H.5v19.542c0 .734.594 1.328 1.328 1.328h23.181c.734 0 1.328-.594 1.328-1.328V2.984l-15.73-.001V.5Zm-1.001 1 .001 2.484 15.73-.001v16.059a.327.327 0 0 1-.328.328H1.828l-.066-.007a.327.327 0 0 1-.262-.321V1.5h8.106Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgVideoFolder;
